module.exports = "/subscriptions/assets/e7a2c8920f77c78fca224fb27fb0a578.svg";